import { getDataflowColumnPreviewUrl, getPaginatedCodelistUrl } from "../../../constants/urls";
import { REQUEST_METHOD_POST, allRequest, postRequest } from "../../../middlewares/api/actions";
import { getFilterObjFromStr, getServerQueryObj } from "../../../utils/filter";
import { convertFilterStrWithSimpleFilterForTimePeriod } from "../../tree-filter/utils";

export const ANNOTATIONS_FORM_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ = 'ANNOTATIONS_FORM_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ';
export const ANNOTATIONS_FORM_DATAFLOW_BUILDER_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ = 'ANNOTATIONS_FORM_DATAFLOW_BUILDER_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ';
export const ANNOTATIONS_FORM_DEFAULT_FILTERS_SHOW_SELECTOR = 'ANNOTATIONS_FORM_DEFAULT_FILTERS_SHOW_SELECTOR';
export const ANNOTATIONS_FORM_DEFAULT_FILTERS_HIDE_SELECTOR = 'ANNOTATIONS_FORM_DEFAULT_FILTERS_HIDE_SELECTOR';

export const showAnnotationsFormDefaultFiltersSelector = (codelistTriplet, item) => ({
  type: ANNOTATIONS_FORM_DEFAULT_FILTERS_SHOW_SELECTOR,
  codelistTriplet,
  item
});

export const hideAnnotationsFormDefaultFiltersSelector = () => ({
  type: ANNOTATIONS_FORM_DEFAULT_FILTERS_HIDE_SELECTOR
});

export const readAnnotationsFormDefaultFiltersItems = ({
  codelistTriplet,
  language,
  pageNum,
  pageSize,
  searchText,
  filters,
  sortCol,
  sortByDesc
}) =>
  postRequest(
    ANNOTATIONS_FORM_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ,
    getPaginatedCodelistUrl(),
    ({
      Id: codelistTriplet.id,
      AgencyId: codelistTriplet.agencyID,
      Version: codelistTriplet.version,
      Lang: language,
      PageNum: pageNum,
      PageSize: pageSize,
      AllSearch: searchText,
      CodeSearch: filters.id ? filters.id : undefined,
      NameSearch: filters.name ? filters.name : undefined,
      ParentSearch: filters.parent ? filters.parent : undefined,
      SortColumn: sortCol ? sortCol : undefined,
      SortDesc: sortByDesc ? sortByDesc : undefined,
      rebuildDb: false
    })
  );

export const readAnnotationsFormDataflowBuilderDefaultFiltersItems = ({
  codelistTriplet,
  language,
  pageNum,
  pageSize,
  searchText,
  filters,
  sortCol,
  sortByDesc
},
  cubeId,
  colNames,
  colName,
  filterStr
) =>
({
  ...allRequest(
    ANNOTATIONS_FORM_DATAFLOW_BUILDER_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ,
    [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
    [getPaginatedCodelistUrl(), getDataflowColumnPreviewUrl(colName, 1, -1)],
    [{
      Id: codelistTriplet.id,
      AgencyId: codelistTriplet.agencyID,
      Version: codelistTriplet.version,
      Lang: language,
      PageNum: pageNum,
      PageSize: pageSize,
      AllSearch: searchText,
      CodeSearch: filters.id ? filters.id : undefined,
      NameSearch: filters.name ? filters.name : undefined,
      ParentSearch: filters.parent ? filters.parent : undefined,
      SortColumn: sortCol ? sortCol : undefined,
      SortDesc: sortByDesc ? sortByDesc : undefined,
      rebuildDb: false
    },
    {
      idCube: cubeId,
      dataflowColumns: colNames,
      filter: getServerQueryObj(undefined, getFilterObjFromStr(convertFilterStrWithSimpleFilterForTimePeriod(filterStr))).Filter
    }
    ]
  ),
  colName
});